module.exports = __webpack_public_path__ + "img/zhuanpan.0a56de8b.png";